import { useQuery, UseQueryOptions } from 'react-query';

import { userApi } from 'src/Services/API';
import { UserWithPrivateInfoDto } from 'src/Services/API/generated';

const useFetchUser = (
  options?: UseQueryOptions<UserWithPrivateInfoDto, unknown, UserWithPrivateInfoDto, string[]>
) => {
  return useQuery({
    ...options,
    queryKey: ['fetch-user'],
    queryFn: async () => {
      return (await userApi.userControllerFindOne()).data;
    },
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export default useFetchUser;
